import { useEffect } from "react";

/**
 * useContextSync Hook
 * Phase 1 Day 45 - Extract context synchronization effects
 *
 * Synchronizes modal states with OrgInstallContext for cross-component communication.
 * Used when selectors need to open modals in AppContent.
 */
export function useContextSync({
  orgInstallContext,
  isInstallationManagementOpen,
  isOrganizationManagementOpen,
  setInstallationManagementOpen,
  setIsOrganizationManagementOpen,
}) {
  // Sync installation management modal state with context (for opening from selector)
  useEffect(() => {
    if (
      orgInstallContext?.showInstallationManagement &&
      !isInstallationManagementOpen
    ) {
      setInstallationManagementOpen(true, null);
      // Clear the context flag
      if (orgInstallContext.setShowInstallationManagement) {
        orgInstallContext.setShowInstallationManagement(false);
      }
    }
  }, [
    orgInstallContext,
    isInstallationManagementOpen,
    setInstallationManagementOpen,
  ]);

  // Sync organization management modal state with context (for opening from selector)
  useEffect(() => {
    if (
      orgInstallContext?.showOrganizationManagement &&
      !isOrganizationManagementOpen
    ) {
      setIsOrganizationManagementOpen(true);
      // Clear the context flag
      if (orgInstallContext.setShowOrganizationManagement) {
        orgInstallContext.setShowOrganizationManagement(false);
      }
    }
  }, [
    orgInstallContext,
    isOrganizationManagementOpen,
    setIsOrganizationManagementOpen,
  ]);
}
